var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.566 10.0254C20.9809 9.32291 20.1145 8.91605 19.2003 8.91449H14.5099L15.0859 7.44361C15.5723 6.13634 15.3859 4.67361 14.5872 3.53008C13.7886 2.38654 12.4795 1.7079 11.0847 1.71439C10.6806 1.71523 10.3144 1.95265 10.1487 2.32125L7.21723 8.91449H4.80005C3.09584 8.91449 1.71429 10.296 1.71429 12.0002V19.2003C1.71429 20.9046 3.09584 22.2861 4.80005 22.2861H17.894C19.3836 22.2856 20.6602 21.2211 20.9283 19.7558L22.2346 12.5557C22.3982 11.6548 22.1532 10.7278 21.566 10.0254ZM6.85723 20.2289H4.80005C4.23198 20.2289 3.77147 19.7684 3.77147 19.2003V12.0002C3.77147 11.4322 4.23198 10.9717 4.80005 10.9717H6.85723V20.2289ZM18.9225 19.3855L20.2288 12.1854C20.2796 11.883 20.1929 11.5738 19.9923 11.342C19.7965 11.1069 19.5062 10.9712 19.2003 10.9717H14.5099C13.8363 10.9705 13.2059 10.6396 12.8223 10.0858C12.4388 9.53199 12.3507 8.82551 12.5864 8.19448L13.1316 6.7236C13.3484 6.15721 13.3184 5.52594 13.0487 4.98271C12.779 4.43949 12.2944 4.03387 11.7122 3.86413L8.9144 10.1591V20.2289H17.894C18.3969 20.2371 18.8321 19.8803 18.9225 19.3855Z",
    fill: "#F7B500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.db50dcdb8991173b6c98df04942ed132.svg";
export { ForwardRef as ReactComponent };